import { executeAPI } from "repositories/db-repository"
// helpers/transaction-helper.js
export async function insertPurchaseOrder(payload, createdBy, onSuccess, onError) {
  try {
    const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
    const res = await fetch(`${base}/purchase-orders`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, createdBy: createdBy })
    })

    const json = await res.json().catch(() => ({}))

    if (!res.ok) {
      // ATALLA-345: surface pesan spesifik dari errors (mis. po_number unique) —
      // json.message dari handler validasi cuma "Invalid provided data." yang tidak informatif.
      const flat = json?.errors && typeof json.errors === "object"
        ? Object.values(json.errors).flat().filter(Boolean)
        : []
      onError?.(flat.length > 0 ? String(flat[0]) : (json?.message || "Request gagal"), json?.errors)
      return
    }

    onSuccess?.(json, json?.message)
  } catch (e) {
    onError?.(e?.message || "Network error")
  }
}

// helpers/transaction-helper.js
// Order HO ke Customer: POST payload minimal ke endpoint tipis createHoOrder.
// Server yang menghitung finansial (amount/dpp/ppn/nett) + memotong stok HO.
export async function insertHoOrder(payload, createdBy, onSuccess, onError) {
  try {
    const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
    const res = await fetch(`${base}/orders/ho-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, created_by: createdBy }),
    })

    const json = await res.json().catch(() => ({}))

    if (!res.ok || json?.success === 0) {
      const flat = json?.errors && typeof json.errors === "object"
        ? Object.values(json.errors).flat().filter(Boolean)
        : []
      onError?.(flat.length > 0 ? String(flat[0]) : (json?.message || "Request gagal"), json?.errors)
      return
    }

    onSuccess?.(json, json?.message)
  } catch (e) {
    onError?.(e?.message || "Network error")
  }
}

// helpers/transaction-helper.js
export async function insertPurchaseReturnFromReceipt(receiptId, payload, userName, onSuccess, onError) {
  try {
    const base = (process.env.REACT_APP_INVENTORY_API_URL || "").replace(/\/$/, "")
    const url = `${base}/goods-receipts/${receiptId}/purchase-returns`

    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload ? JSON.stringify(payload) : null,
    })

    const json = await res.json().catch(() => ({}))
    if (!res.ok) throw new Error(json?.message || "Request gagal")

    onSuccess?.(json?.data || json, json?.message)
  } catch (e) {
    onError?.(e?.message || "Request gagal")
  }
}